var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skills page"},_vm._l((_vm.skills),function(s,i){return _c('div',{key:i,staticClass:"skill"},[_c('h2',[_vm._v(_vm._s(s.name))]),_c('p',{staticClass:"comment"},[_vm._v(_vm._s(s.comment))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }